import OccupiedEventsProvider from '../providers/OccupiedEventsProvider'

var OccupiedEventsService = function () {
  return {
    async GetOccupiedEventsAsync (uniqueid, componentid, field, range) {
      return OccupiedEventsProvider.GetOccupiedEventsAsync(uniqueid, componentid, field, range)
    }
  }
}
export default new OccupiedEventsService()



// WEBPACK FOOTER //
// ./src/services/OccupiedEventsService.js